export const TRANSMISSION_TYPES_IDS = {
  AUTOMATIC: '1',
  MANUAL: '2'
}

export const TRANSMISSION_TYPES = {
  [TRANSMISSION_TYPES_IDS.AUTOMATIC]: {
    id: TRANSMISSION_TYPES_IDS.AUTOMATIC,
    name: 'COMMON.TRANSMISSION_AUTOMATIC'
  },
  [TRANSMISSION_TYPES_IDS.MANUAL]: {
    id: TRANSMISSION_TYPES_IDS.MANUAL,
    name: 'COMMON.TRANSMISSION_MANUAL'
  }
}
